import axios from "../../../utils/axios";

export const patchRequest = async ({id, data}) => {

    const response = await axios.patch(`/blogs/${id}`,data);

    return response.data;
};